export default __webpack_public_path__ + "static/media/Audio.5924de28.svg";